<div class="dialog" fxLayout="column">

  <div mat-dialog-header>
    <div class="dialog-title" fxLayout="row" fxLayoutAlign="space-between end">
      <div fxLayout="row" fxLayoutGap="10px">
        <mat-icon>create</mat-icon>
        <h1 *ngIf="!isAdded">{{'建物・カテゴリ情報：編集' | translate}}</h1>
        <h1 *ngIf="!!isAdded">{{'建物・カテゴリ情報：追加' | translate}}</h1>
      </div>

      <div fxLayout="row" fxLayoutGap="8px">
        <button mat-raised-button color="primary" (click)="addHall()" [disabled]="!hallFormGroup.valid">
          <mat-icon>add</mat-icon>
          <span *ngIf="!isAdded">{{'更新' | translate}}</span>
          <span *ngIf="!!isAdded">{{'追加' | translate}}</span>
        </button>
        <button mat-button (click)="onNoClick()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div mat-dialog-content fxFlex="600px" style="overflow: auto;">
    <form class="form" [formGroup]="hallFormGroup">
      <div class="dialog-body" fxLayout="column" fxLayoutGap="24px">
        <mat-form-field>
          <mat-label floatLabel="always">ID</mat-label>
          <input matInput *ngIf="!isAdded" placeholder="ID" id="hallId" formControlName="hallId" readonly>
          <input matInput *ngIf="!!isAdded" placeholder="ID" id="hallId" formControlName="hallId">
          <mat-error *ngIf="hallIdControl.invalid">{{ getErrorMessageToHallId() }}</mat-error>
        </mat-form-field>

        <mat-form-field>
          <mat-label floatLabel="always">{{'説明' | translate}}</mat-label>
          <input matInput placeholder="{{'説明' | translate}}" id="hallExplain" formControlName="hallExplain">
        </mat-form-field>

        <mat-form-field>
          <mat-label floatLabel="always">{{'名称' | translate}}</mat-label>
          <input matInput placeholder="{{'名称' | translate}}" id="hallName"
            value="{{ hall!.hall_names | multiName:projectLanguages:projectBaseLang }}" readonly>
          <button matSuffix mat-stroked-button color="primary" (click)="openHallNameDialog()">
            <mat-icon>edit</mat-icon>
          </button>
          <mat-error *ngIf="hallNameControl.invalid">{{ getErrorMessageToHallName() }}</mat-error>
        </mat-form-field>

        <google-map *ngIf="center" height="400px" width="100%" step="0.00000001" [center]="center" [zoom]="zoom"
          [options]="options">
          <map-marker #markerElem *ngIf="currentPosition" step="0.00000001" [position]="currentPosition"
            [options]="currentPositionMarkerOption" (mapDragend)="onMerkerDragEnd($event)">
          </map-marker>
        </google-map>
        <input #mapSearchField class="map-search-field" type="text"
          (keydown)="onKeyDownFromSearchPlace($event.keyCode)" />
        <button #mapSearchFieldExecute (click)="searchMap()">{{'移動' | translate}}</button>
        <button #mapSearchFieldClear (click)="clearMapSearchField()">{{'クリア' | translate}}</button>

        <div class="hall-area" fxLayout="row" fxLayoutGap="20px">
          <mat-form-field fxFlex="50%">
            <mat-label floatLabel="always">{{'緯度' | translate}}</mat-label>
            <input matInput placeholder="{{'緯度' | translate}}" id="hallLat" formControlName="hallLat" type="number"
              step="0.00000001" (change)="onBlurMarkerLat()">
            <mat-error *ngIf="hallLatControl.invalid">{{ getErrorMessageToHallLat() }}</mat-error>
          </mat-form-field>

          <mat-form-field fxFlex="50%">
            <mat-label floatLabel="always">{{'経度' | translate}}</mat-label>
            <input matInput placeholder="{{'経度' | translate}}" id="hallLng" formControlName="hallLng" type="number"
              step="0.00000001" (change)="onBlurMarkerLng()">
            <mat-error *ngIf="hallLngControl.invalid">{{ getErrorMessageToHallLng() }}</mat-error>
          </mat-form-field>
        </div>

        <mat-checkbox class="show-marker" formControlName="showMarker" color="primary">{{'MAPページに位置を表示する' | translate}}</mat-checkbox>

        <mat-form-field>
          <mat-label floatLabel="always">{{'メニュー表示タイプ' | translate}}</mat-label>
          <mat-select placeholder="{{'メニュー表示タイプ' | translate}}" id="menuDispType" formControlName="menuDispType">
            <mat-option *ngFor="let menuDispType of menuDispTypes" [value]="menuDispType">{{ menuDispType | typeOfMenu
              }}</mat-option>
          </mat-select>
          <mat-error *ngIf="menuDispTypeControl.invalid">{{ getErrorMessageToMenuDispType() }}</mat-error>
        </mat-form-field>

        <mat-form-field *ngIf="menuDispTypeControl.value===MENU_DISP_TYPE_MENU">
          <mat-label floatLabel="always">{{'「メニュー」の使用について' | translate}}</mat-label>
          <mat-select placeholder="{{'「メニュー」の使用について' | translate}}" id="useCustomMenu" formControlName="useCustomMenu">
            <mat-option *ngFor="let useCustomMenu of useFunctions" [value]="useCustomMenu">{{ useCustomMenu | useFunction }}</mat-option>
          </mat-select>
          <mat-error *ngIf="useCustomMenuControl.invalid">{{ getErrorMessageToUseCustomMenu() }}</mat-error>
        </mat-form-field>

        <mat-form-field *ngIf="menuDispTypeControl.value===MENU_DISP_TYPE_MENU">
          <mat-label floatLabel="always">{{'メニュー表示範囲指定（緯度経度からの距離(m)）' | translate}}</mat-label>
          <mat-select placeholder="{{'メニュー表示範囲指定（緯度経度からの距離(m)）' | translate}}" id="menuDispMapRange"
            formControlName="menuDispMapRange" [disabled]="!!this.showPaidContentControl.value">
            <mat-option *ngFor="let menuDispMapRange of menuDispMapRanges" [value]="menuDispMapRange">{{
              menuDispMapRange | menuDispMapRange }}</mat-option>
          </mat-select>
          <mat-error *ngIf="menuDispMapRangeControl.invalid">{{ getErrorMessageToMenuDispMapRange() }}</mat-error>
        </mat-form-field>

        <!-- <mat-checkbox formControlName="useCustomMenuIcon" color="primary" (change)="onChangeUseCustomMenuIcon()">登録画像をメニューアイコンとして使用する</mat-checkbox>

        <div class="select-favicon-file" *ngIf="!!useCustomMenuIconControl.value">
          <div class="favicon-file-title" fxLayout="row" fxLayoutAlign="space-between end">
            <span>{{'メニューアイコン画像ファイル' | translate}}</span>
            <button mat-stroked-button (click)="openSelectCustomMenuIconFileDialog()">
              <mat-icon>add</mat-icon>
              <span>{{'ファイル選択' | translate}}</span>
            </button>
          </div>
          <table>
            <thead>
              <tr>
                <th>{{'画像' | translate}}</th>
                <th>{{'名称' | translate}}</th>
                <th>{{'削除' | translate}}</th>
              </tr>
            </thead>
            <tr *ngIf="!!customMenuIconFile">
              <td><img [src]="(hall!.custom_menu_icon_file! | doc:uploadedFilesCollectionName | async)?.download_url"
                  height="40px" width="auto"></td>
              <td>{{ customMenuIconFile.file_name }}</td>
              <td>
                <button mat-stroked-button color="warn" (click)="deleteCustomMenuIconFile()">
                  <mat-icon>clear</mat-icon>
                </button>
              </td>
            </tr>
          </table>
        </div>

        <div class="select-favicon-file" *ngIf="!useCustomMenuIconControl.value">
          <div class="favicon-file-title" fxLayout="row" fxLayoutAlign="space-between end">
            <span>{{'メニューアイコン画像ファイル' | translate}}</span>
            <button mat-stroked-button (click)="openSelectMenuIconDialog()">
              <mat-icon>add</mat-icon>
              <span>{{'ファイル選択' | translate}}</span>
            </button>
          </div>
          <table>
            <thead>
              <tr>
                <th>{{'画像' | translate}}</th>
                <th>{{'名称' | translate}}</th>
                <th>{{'削除' | translate}}</th>
              </tr>
            </thead>
            <tr *ngIf="!!hall?.menu_icon">
              <td><span class="material-icons">{{ hall?.menu_icon }}</span></td>
              <td>{{ hall?.menu_icon }}</td>
              <td>
                <button mat-stroked-button color="warn" (click)="deleteMenuIconFile()">
                  <mat-icon>clear</mat-icon>
                </button>
              </td>
            </tr>
          </table>
        </div> -->

        <mat-checkbox formControlName="useCustomSideIcon" color="primary" (change)="onChangeUseCustomSideIcon()">{{ '登録画像をメニューアイコンとして使用する' | translate }}</mat-checkbox>

        <div class="select-favicon-file" *ngIf="!!useCustomSideIconControl.value">
          <div class="favicon-file-title" fxLayout="row" fxLayoutAlign="space-between end">
            <span>{{ 'メニューアイコン画像ファイル' | translate }}</span>
            <button mat-stroked-button (click)="openSelectCustomSideIconFileDialog()">
              <mat-icon>add</mat-icon>
              <span>{{'ファイル選択' | translate}}</span>
            </button>
          </div>
          <table>
            <thead>
              <tr>
                <th>{{'画像' | translate}}</th>
                <th>{{'名称' | translate}}</th>
                <th>{{'削除' | translate}}</th>
              </tr>
            </thead>
            <tr *ngIf="!!customSideIconFile">
              <td><img [src]="(hall!.custom_side_icon_file! | doc:uploadedFilesCollectionName | async)?.download_url"
                  height="40px" width="auto"></td>
              <td>{{ customSideIconFile.file_name }}</td>
              <td>
                <button mat-stroked-button color="warn" (click)="deleteCustomSideIconFile()">
                  <mat-icon>clear</mat-icon>
                </button>
              </td>
            </tr>
          </table>
        </div>

        <div class="select-favicon-file" *ngIf="!useCustomSideIconControl.value">
          <div class="favicon-file-title" fxLayout="row" fxLayoutAlign="space-between end">
            <span>{{ 'メニューアイコン画像ファイル' | translate }}</span>
            <button mat-stroked-button (click)="openSelectSideIconDialog()">
              <mat-icon>add</mat-icon>
              <span>{{'ファイル選択' | translate}}</span>
            </button>
          </div>
          <table>
            <thead>
              <tr>
                <th>{{'画像' | translate}}</th>
                <th>{{'名称' | translate}}</th>
                <th>{{'削除' | translate}}</th>
              </tr>
            </thead>
            <tr *ngIf="!!hall?.side_icon">
              <td><span class="material-icons">{{ hall?.side_icon }}</span></td>
              <td>{{ hall?.side_icon }}</td>
              <td>
                <button mat-stroked-button color="warn" (click)="deleteSideIconFile()">
                  <mat-icon>clear</mat-icon>
                </button>
              </td>
            </tr>
          </table>
        </div>

        <mat-checkbox formControlName="useCustomSideImage" color="primary" (change)="onChangeUseCustomSideImage()">{{ 'カスタム画像ファイルを使用する' | translate }}</mat-checkbox>

        <div class="select-file" *ngIf="!!useCustomSideImageControl.value">
          <div class="favicon-file-title" fxLayout="row" fxLayoutAlign="space-between end">
            <span>{{ '画像ファイル' | translate }}</span>
            <button mat-stroked-button (click)="openSelectCustomSideImageFileDialog()">
              <mat-icon>add</mat-icon>
              <span>{{'ファイル選択' | translate}}</span>
            </button>
          </div>
          <table>
            <thead>
              <tr>
                <th>{{'画像' | translate}}</th>
                <th>{{'名称' | translate}}</th>
                <th>{{'削除' | translate}}</th>
              </tr>
            </thead>
            <tr *ngIf="!!customSideImageFile || !!hall?.custom_side_image_file">
              <td><img [src]="(hall!.custom_side_image_file! | doc:uploadedFilesCollectionName | async)?.download_url"
                  height="40px" width="auto"></td>
              <td>{{ customSideImageFile?.file_name || hall?.custom_side_image_file }}</td>
              <td>
                <button mat-stroked-button color="warn" (click)="deleteCustomSideImageFile()">
                  <mat-icon>clear</mat-icon>
                </button>
              </td>
            </tr>
          </table>
        </div>

        <mat-checkbox formControlName="showPaidContent" color="primary"
          (change)="changeShowPaidContent()">{{'有償コンテンツを表示する' | translate}}</mat-checkbox>

        <ng-container *ngIf="!!showPaidContentControl.value">

          <div class="icon-text">
            <span class="pagetitle">{{'有償コンテンツ関連情報' | translate}}</span>
          </div>

          <mat-form-field>
            <mat-label floatLabel="always">{{'詳細' | translate}}</mat-label>
            <textarea matInput placeholder="{{'詳細' | translate}}" id="hallDescs" rows="3"
              value="{{ hall!.hall_descs | multiDesc:projectLanguages:projectBaseLang }}" readonly></textarea>
            <button matSuffix mat-stroked-button color="primary" (click)="openHallDescDialog()">
              <mat-icon>edit</mat-icon>
            </button>
            <mat-error *ngIf="hallDescsControl.invalid">{{ getErrorMessageToHallDescs() }}</mat-error>
          </mat-form-field>

          <div fxLayout="row" fxLayoutGap="20px">
            <mat-form-field fxFlex="50%">
              <mat-label>{{'販売期間(開始日)' | translate}}</mat-label>
              <input matInput [matDatepicker]="salesStartDatePicker" placeholder="{{'販売期間(開始日)' | translate}}"
                formControlName="salesStartDate" readonly>
              <button mat-button matSuffix aria-label="Clear" (click)="clearSalesStartDate()">
                <mat-icon>close</mat-icon>
              </button>
              <mat-datepicker-toggle matSuffix [for]="$any(salesStartDatePicker)"></mat-datepicker-toggle>
              <mat-datepicker #salesStartDatePicker></mat-datepicker>
            </mat-form-field>
            <mat-form-field fxFlex="50%">
              <mat-label>{{'販売期間(終了日)' | translate}}</mat-label>
              <input matInput [matDatepicker]="salesEndDatePicker" placeholder="{{'販売期間(終了日)' | translate}}"
                formControlName="salesEndDate" readonly>
              <button mat-button matSuffix aria-label="Clear" (click)="clearSalesEndDate()">
                <mat-icon>close</mat-icon>
              </button>
              <mat-datepicker-toggle matSuffix [for]="$any(salesEndDatePicker)"></mat-datepicker-toggle>
              <mat-datepicker #salesEndDatePicker></mat-datepicker>
              <mat-error *ngIf="salesEndDateControl.hasError('before_start_date')">{{ getErrorMessageToSalesEndDate()
                }}</mat-error>
            </mat-form-field>
          </div>

          <div class="hall-area" fxLayout="row" fxLayoutGap="20px">
            <mat-form-field fxFlex="50%">
              <mat-label floatLabel="always">{{'価格' | translate}}</mat-label>
              <input matInput type="number" min="0" placeholder="{{'価格' | translate}}" id="price"
                formControlName="price">
              <mat-error *ngIf="priceControl.invalid">{{ getErrorMessageToPrice() }}</mat-error>
            </mat-form-field>

            <mat-form-field fxFlex="50%">
              <mat-label floatLabel="always">{{'有効期間' | translate}}</mat-label>
              <mat-select placeholder="{{'有効期間' | translate}}" id="validityPeriod" formControlName="validityPeriod">
                <mat-option [value]="1">{{'購入当日中' | translate}}</mat-option>
                <mat-option [value]="2">{{'購入翌日中' | translate}}</mat-option>
                <mat-option [value]="3">{{'購入から3日間' | translate}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

        </ng-container>

      </div>
    </form>
  </div>


</div>